import { useEffect } from 'react';
import { useEnvelopesNeedsReminders } from '@/views/Home/hooks';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import {
  InteractionSelectionModal,
  type InteractionSelectionModalProps,
} from './InteractionSelectionModal';

interface Props
  extends Pick<InteractionSelectionModalProps, 'numItems' | 'open'> {
  onClose: () => void;
}

export const EnvelopeRemindersInteractionSelectionModal = ({
  numItems,
  onClose,
  open,
}: Props) => {
  const trackEvent = useTrackHomePageAnalytics();
  const { envelopeInteractions, loading, onLoadMore } =
    useEnvelopesNeedsReminders({ skip: !open });

  const handleClose = (eventTarget: string) => {
    onClose();
    trackEvent(TrackHomePageEvent.NeedsAttentionModalClose, { eventTarget });
  };

  useEffect(() => {
    if (open) {
      trackEvent(TrackHomePageEvent.NeedsAttentionModalMount);
    }
  }, [open, trackEvent]);

  return (
    <InteractionSelectionModal
      onClose={handleClose}
      loading={loading}
      numItems={numItems}
      interactions={envelopeInteractions}
      open={open}
      modalSubtitle="There are multiple transactions that have envelopes that are partially signed or not signed and may need reminders sent"
      onLoadMore={onLoadMore}
    />
  );
};
